module.exports = __webpack_public_path__ + "static/44-Nielsen-05830360eb3c443de180fdd9a7b180bc.png";